
$(() => {

  $('.auto-toast .toast').each(function() {
    const toast = new bootstrap.Toast(this);
    toast.show();
  });
});